module.exports = __webpack_public_path__ + "static/img/today_area_best_team.b9dc9fac.png";